import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../../assets/images/logo/iknowa-logo-v4.svg'


const _withScopeId = n => (_pushScopeId("data-v-e5f48f84"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", { class: "custom__modal__header" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "open-logo",
    src: _imports_0
  }),
  /*#__PURE__*/_createElementVNode("h4", null, "Company Setup")
], -1))
const _hoisted_3 = { class: "custom__modal__content" }
const _hoisted_4 = { class: "custom__modal__heading" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "description" }, " Before you can bid on new project, we need to understand how you're setup as a business. ", -1))
const _hoisted_8 = { class: "modal_card_content" }
const _hoisted_9 = { class: "icon_btn" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal_content" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Sole Trader"),
  /*#__PURE__*/_createElementVNode("p", null, "This can also include partnerships")
], -1))
const _hoisted_11 = { class: "icon_btn" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal_content" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Limited Company"),
  /*#__PURE__*/_createElementVNode("p", null, "Registered on Companies House")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_SoleTraderWorkStationComponent = _resolveComponent("SoleTraderWorkStationComponent")!
  const _component_LimitedCompanyWorkStationComponent = _resolveComponent("LimitedCompanyWorkStationComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_dialog, {
      modelValue: $setup.isShowLandlordsWorkStation,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.isShowLandlordsWorkStation) = $event)),
      width: "968px",
      class: "custom__modal__box landlord__modal__box",
      height: "100%",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_btn, {
          variant: "text",
          "aria-label": "Refresh",
          class: "back_btn",
          "prepend-icon": "mdi-chevron-left",
          onClick: $setup.onClickToggleTradesWorkStation
        }, {
          default: _withCtx(() => [
            _createTextVNode("back")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createElementVNode("main", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h3", _hoisted_5, [
                _createTextVNode(" Great stuff. What type of company do "),
                _hoisted_6,
                _createTextVNode(" you have, " + _toDisplayString($setup.user?.firstName) + "? ", 1)
              ]),
              _hoisted_7
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_v_card, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.onClickSoleTrader())),
                class: "modal_card"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_v_btn, {
                      color: "#0c0f4a",
                      size: "large",
                      variant: "tonal",
                      "aria-label": "Refresh",
                      icon: "mdi-home",
                      class: "icon_home"
                    })
                  ]),
                  _hoisted_10
                ]),
                _: 1
              }),
              _createVNode(_component_v_card, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.onClickLimitedCompany())),
                class: "modal_card"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_v_btn, {
                      color: "#0c0f4a",
                      size: "large",
                      variant: "tonal",
                      "aria-label": "Refresh",
                      icon: "mdi-home",
                      class: "icon_home"
                    })
                  ]),
                  _hoisted_12
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    ($setup.isShowSoleTraderWorkStation)
      ? (_openBlock(), _createBlock(_component_SoleTraderWorkStationComponent, {
          key: 0,
          onOnClickCloseTab: $setup.onClickCloseSoloTrader
        }, null, 8, ["onOnClickCloseTab"]))
      : _createCommentVNode("", true),
    ($setup.isShowLimitedCompanyWorkStation)
      ? (_openBlock(), _createBlock(_component_LimitedCompanyWorkStationComponent, {
          key: 1,
          onOnClickCloseTab: $setup.onClickCloseLimitedCompany
        }, null, 8, ["onOnClickCloseTab"]))
      : _createCommentVNode("", true)
  ], 64))
}